export default __webpack_public_path__ + "static/media/noa-23.70d2574c.jpg";